import { Container } from 'src/components/Container/Container'
import { Headline } from 'src/components/Headline/Headline'
import { Image } from 'src/components/Image/Image'
import { Text } from 'src/components/Text/Text'

import styles from './AuthorSummary.module.scss'

import type { Author } from 'src/types/Author'

export interface AuthorSummaryProps {
  author: Author
}

export const AuthorSummary = ({ author }: AuthorSummaryProps) => (
  <Container>
    <div className={styles.inner}>
      {author.imageId && (
        <div className={styles.image}>
          <Image
            identifier={author.imageId}
            srcSet={[180, 360]}
            sizes="180px"
            alt={author.name}
            width="180"
            height="180"
          />
        </div>
      )}

      <Container className={styles.text}>
        <Headline variant="h4">{author.name}</Headline>
        <Text variant="p">{author.description}</Text>
      </Container>
    </div>
  </Container>
)
